// Mock data for Ploy's Thai Food Menu
export const menuData = {
  restaurantInfo: {
    name: "Ploy's Thai Food",
    tagline: "Authentic Thai Cuisine",
    hours: "Mon-Saturday 11-3 / 4:30-9:30pm",
    address: "7309 SW Garden Home Rd, PDX 97223",
    phone: "(503) 894-9034",
    orderUrl: "#order"
  },

  menuSections: [
    {
      id: "appetizers",
      title: "Appetizers",
      subtitle: "Start your Thai journey",
      items: [
        {
          name: "Salad Rolls",
          description: "Tasty vegetable wraps with peanut sauce.",
          tags: ["GF", "N"],
          variants: [
            { name: "Fried Tofu (VG)", price: 8 },
            { name: "Lemongrass Chicken", price: 8 },
            { name: "Tasty Shrimp", price: 9 }
          ]
        },
        {
          name: "Egg Rolls",
          portion: "(4 Piece)",
          description: "Mixed vegetables with silky glass noodles.",
          price: 6,
          tags: []
        },
        {
          name: "Fried Tofu",
          description: "Deep-fried fresh tofu, peanuts, fresh green onions, & sweet & sour sauce.",
          price: 7,
          tags: ["GF", "V", "N"]
        },
        {
          name: "Fried Wontons",
          portion: "(6 Pieces)",
          description: "Deep-fried wontons stuffed with ground chicken & herbs, with sweet & sour sauce.",
          price: 7,
          tags: []
        },
        {
          name: "Shrimp Tempura",
          portion: "(5 Piece)",
          description: "Deep-fried, with spicy mayo & sweet & sour sauce.",
          price: 11,
          tags: []
        },
        {
          name: "Chicken Satay",
          portion: "(4 Piece)",
          description: "Grilled marinated chicken, coconut milk, curry powder & Thai herbs, with cucumber salad sauce & peanut sauce.",
          price: 11,
          tags: ["GF", "N"]
        },
        {
          name: "Crab Puffs",
          portion: "(6 Piece)",
          description: "Deep-fried stuffed wontons with cream cheese, onion, imitation crab meat, & sweet & sour sauce.",
          price: 8,
          tags: []
        },
        {
          name: "Calamari Tempura",
          description: "Deep-fried, with spicy mayo & sweet & sour sauce.",
          price: 12,
          tags: []
        },
        {
          name: "Super Appetizer Platter",
          description: "Combination of our top appetizers: egg rolls, crab puffs, fried wonton, tofu salad rolls, & chicken potstickers.",
          price: 15,
          tags: ["NH"]
        },
        {
          name: "Chicken Potstickers",
          portion: "(6 Piece)",
          description: "Deep-fried or steamed, with garlic black soy sauce.",
          price: 8,
          tags: ["NH"]
        },
        {
          name: "Sesame Balls",
          portion: "(6 Piece)",
          description: "Fried sesame balls.",
          price: 6,
          tags: []
        }
      ]
    },
    {
      id: "soups",
      title: "Soups",
      subtitle: "Warm up with traditional Thai faves",
      pricingTiers: [
        { protein: "Chicken, Tofu, or Vegetables", singlePrice: 16 },
        { protein: "Beef, Shrimp, or Squid", singlePrice: 19 },
        { protein: "Seafood (Shrimps, Squid, Scallops, & Mussels)", singlePrice: 22 }
      ],
      items: [
        {
          name: "Tom Kah",
          description: "Coconut lemongrass soup with galangal roots, kaffir leaf, tomato, onion, mushroom & cilantro.",
          tags: ["GF"]
        },
        {
          name: "Tom Yum",
          description: "Hot & sour lemongrass soup with galangal roots, kaffir leaf, tomato, onion, mushroom & cilantro.",
          tags: ["GF", "MILD"]
        },
        {
          name: "Wonton",
          description: "Steamed chicken pot-stickers, veggies, green onion, beansprout, cilantro, & kaffir leaf.",
          price: 16,
          tags: ["NH"]
        },
        {
          name: "Poh Tak",
          description: "Hot & sour lemongrass soup, with seafood & sweet basil.",
          price: 21,
          tags: ["GF", "MEDIUM"]
        },
        {
          name: "Thai Noodle Soup",
          description: "Clear broth noodle soup with rice noodles, green onion, fried garlic, beansprout & cilantro.",
          price: 16,
          tags: ["GF", "N"]
        },
        {
          name: "Ploy's Tom Yum Soup",
          description: "Hot & sour soup with tiny rice noodles, ground chicken, shrimp, squid, beansprout, green onion cilantro & ground peanut.",
          price: 18,
          tags: ["GF", "N", "MEDIUM"]
        }
      ]
    },
    {
      id: "stirfry",
      title: "Noodles, Stirfry, Curry & Fried Rice",
      pricingTiers: [
        {
          protein: "Chicken, Tofu, Vegetables",
          lunch: { price: 14, note: "M-F 11-3PM" },
          dinner: { price: 16 }
        },
        {
          protein: "Beef, Shrimp, Squid",
          lunch: { price: 16, note: "M-F 11-3PM" },
          dinner: { price: 19 }
        },
        {
          protein: "Seafood (Shrimps, Squid, Scallops, & Mussels)",
          lunch: { price: 17, note: "M-F 11-3PM", detail: "with jasmine rice (except noodles)" },
          dinner: { price: 22 }
        }
      ],
      subgroups: [
        {
          id: "noodles",
          title: "Noodles",
          subtitle: "Classic Thai noodle dishes",
          items: [
            {
              name: "Pad Thai",
              description: "Rice noodle, eggs, green onion, bean sprout, house pad thai sauce, & ground peanuts.",
              tags: ["N"]
            },
            {
              name: "Pad Thai Woon Sen",
              description: "Glass noodles, eggs, green onion, bean sprout, special house pad thai sauce, & ground peanut on the side. (Tofu option comes with broccoli, cabbage, & carrot)",
              tags: ["N"]
            },
            {
              name: "Pad Kee Mao",
              description: "Wide rice noodles, eggs, onion, bell peppers, tomatoes, mushrooms & sweet basil.",
              tags: ["MEDIUM"]
            },
            {
              name: "Pad See Ew",
              description: "Pan fried wide rice noodle with eggs, carrots, broccoli, & black soy sauce.",
              tags: []
            },
            {
              name: "Yakisoba",
              description: "Egg noodle with broccoli, cabbage, carrots, onion, & beansprout.",
              tags: []
            }
          ]
        },
        {
          id: "stir-fry",
          title: "Stir Fry",
          subtitle: "Wok-tossed perfection",
          items: [
            {
              name: "Pad Ka Prau",
              description: "Stir-fried with fresh chili, garlic, green beans, bell peppers, & sweet basil.",
              tags: ["MEDIUM"]
            },
            {
              name: "Pad Prik King",
              description: "Stir-fried green beans with sweet curry paste, kaffir leaves & bell peppers.",
              tags: ["GF", "DO"]
            },
            {
              name: "Pra Ram",
              description: "Steamed broccoli, cabbage, & carrots, topped with homemade peanut sauce.",
              tags: ["N"]
            },
            {
              name: "Pad Woon Sen",
              description: "Stir-fried glass noodle, eggs, onion, tomatoes, celery, mushroom, & bell pepper.",
              tags: []
            },
            {
              name: "Pad Eggplant",
              description: "Stir fried eggplant with onions, bell peppers, basil, & sweet chili sauce.",
              tags: []
            },
            {
              name: "Pad Ginger",
              description: "Stir-fried fresh ginger with onions, mushrooms, & bell peppers.",
              tags: []
            },
            {
              name: "Mango Cashew Nut",
              description: "Fresh seasonal mango, stir-fried cashew nuts, carrots, onion, bell peppers, & sweet chili paste.",
              tags: ["N"]
            },
            {
              name: "Cashew Nut",
              description: "Stir-fried cashew nuts mixed with carrots, onions, bell peppers, & sweet chili paste.",
              tags: ["N"]
            },
            {
              name: "Mixed Vegetables",
              description: "Choice of protein with a stir-fry variety of mixed vegetables.",
              tags: []
            },
            {
              name: "Pad Phet",
              description: "Stir-fried curry paste with krachai, eggplant, bamboo shoot, bell peppers, basil, kaffir leaves, green beans, & sweet basil.",
              tags: ["GF", "DO", "MEDIUM"]
            },
            {
              name: "Lemongrass Chicken",
              description: "Lemongrass chicken with peanut sauce & steamed vegetables.",
              tags: ["GF", "N"]
            },
            {
              name: "Garlic & Pepper",
              description: "Stir-fried fresh garlic and pepper on steamed broccoli, cabbage, & carrots.",
              tags: []
            }
          ]
        },
        {
          id: "thai-curry",
          title: "Thai Curry",
          subtitle: "Rich and aromatic curries",
          footnote: "Curry pastes have ka-pi (shrimp & salt)",
          items: [
            {
              name: "Red Curry",
              description: "Red curry paste with coconut milk, eggplant, bamboo shoot, bell peppers & sweet basil.",
              tags: ["GF", "MEDIUM"]
            },
            {
              name: "Green Curry",
              description: "Green curry paste with coconut milk, eggplant, bamboo shoot, bell peppers, & sweet basil.",
              tags: ["GF", "MEDIUM"]
            },
            {
              name: "Yellow Curry",
              description: "Yellow curry paste, coconut milk, curry powder, potato, carrot, onion, & bell peppers.",
              tags: ["V", "GF", "MILD"]
            },
            {
              name: "Noodle Curry",
              description: "Curry paste with broccoli, green beans, bell peppers, carrots & sweet basil.",
              tags: ["GF"]
            },
            {
              name: "Peanut Curry",
              description: "Peanut & curry sauce, green beans, broccoli, bell peppers, carrots, & sweet basil.",
              tags: ["GF", "N"]
            },
            {
              name: "Massaman Curry",
              description: "Massaman curry paste with coconut milk, potatoes, carrots, onions, & peanuts.",
              tags: ["GF", "N", "MILD"]
            },
            {
              name: "Pumpkin Curry",
              description: "Well-known Thai curry dish. Red curry sauce with fresh Asian kabocha pumpkin, bell peppers, & basil. (Not vegan)",
              tags: ["GF", "DO", "MEDIUM"]
            },
            {
              name: "Panang Curry",
              description: "Panang curry paste, coconut milk, green beans, & bell peppers.",
              tags: ["GF", "MEDIUM"]
            }
          ]
        },
        {
          id: "fried-rice",
          title: "Fried Rice",
          subtitle: "Fragrant jasmine rice creations",
          items: [
            {
              name: "Pineapple Fried Rice",
              description: "Jasmine rice, eggs, pineapple, cashew, raisin, onion, tomato, diced vegetables (peas, carrot, green beans) & cilantro.",
              tags: ["N"]
            },
            {
              name: "Basil Fried Rice",
              description: "Jasmine rice with fresh ground chili garlic, eggs, onion, bell peppers, & sweet basil.",
              tags: ["MEDIUM"]
            },
            {
              name: "Fried Rice",
              description: "Jasmine rice, eggs, onions, tomatoes, broccoli, diced vegetables (peas, carrots, green beans), & cilantro.",
              tags: []
            }
          ]
        }
      ]
    },
    {
      id: "specials",
      title: "Ploy's Specials",
      subtitle: "Our signature dishes",
      footnote: "Comes with our Jasmine Rice",
      subgroups: [
        {
          id: "specials-meats",
          title: "Meats",
          items: [
            {
              name: "Tender Beef Curry",
              description: "Marinated, stew-cooked beef strips, made with curry paste, coconut milk, kaffir leaves, green beans & basil.",
              price: 21,
              tags: ["GF", "MEDIUM"]
            },
            {
              name: "Orange Honey Chicken",
              description: "Orange honey chicken topped with a homemade sauce.",
              price: 17,
              tags: []
            },
            {
              name: "Orange Honey Duck",
              description: "Crispy duck & steamed vegetables topped with a homemade sauce.",
              price: 22,
              tags: ["NH"]
            },
            {
              name: "Red Curry Duck",
              description: "Tomatoes, bell peppers, & pineapple. Topped with sweet basil.",
              price: 20,
              tags: ["GF", "NH", "MEDIUM"]
            },
            {
              name: "Duck Pad Thai",
              description: "Duck meat, rice noodle, eggs, green onion, bean sprouts, special house pad thai sauce & ground peanut on the side.",
              price: 21,
              tags: ["N", "NH"]
            },
            {
              name: "Pad Crispy Basil",
              description: "Stir-fried ground chicken & diced shrimp with bell peppers & sweet basil. Topped with Thai crispy basil.",
              price: 22,
              tags: ["GF", "MEDIUM"]
            }
          ]
        },
        {
          id: "specials-seafood",
          title: "Seafood",
          items: [
            {
              name: "Halibut Sam Ros",
              description: "Deep-fried halibut with pineapple, onion, bell peppers, topped with sweet & sour sauce & crispy basil.",
              price: 23,
              tags: []
            },
            {
              name: "Chuchee Jumbo Prawn",
              description: "Prawns with chuchee curry paste, green beans, bell peppers & kaffir leaves.",
              price: 22,
              tags: ["MEDIUM"]
            },
            {
              name: "Garlic Jumbo Prawn",
              description: "Deep-fried jumbo prawns, fresh garlic, bell peppers & steamed mixed vegetables.",
              price: 22,
              tags: []
            },
            {
              name: "Salmon Panang Curry",
              description: "Grilled salmon, panang curry sauce, coconut milk, kaffir leaves, bell peppers & green beans.",
              price: 23,
              tags: ["MEDIUM"]
            },
            {
              name: "Crab Fried Rice",
              description: "Jasmin rice with eggs, onions, tomatoes, diced vegetables (peas/carrot/green beans), chinese broccoli & cilantro.",
              price: 23,
              tags: []
            },
            {
              name: "Crab Pad Thai",
              description: "Super lump crab meat with rice noodle, eggs, green onion, bean sprouts, special house pad thai sauce & ground peanut on the side.",
              price: 21,
              tags: ["N"]
            }
          ]
        }
      ]
    },
    {
      id: "salads",
      title: "Salads",
      subtitle: "Fresh and zesty",
      footnote: "All salads except Papaya have mixed greens",
      items: [
        {
          name: "Papaya Salad",
          description: "Shredded green papaya, tomatoes, garlic, fresh chili, peanut, green beans, fresh lime with palm sugar, & fresh cabbage.",
          price: 13,
          tags: ["GF", "N", "MEDIUM"]
        },
        {
          name: "Lemongrass Chicken Salad",
          description: "Grilled marinated chicken breast, lemongrass, thai herb, tomato, cucumber, green onion, mint, cilantro, & chili-lime dressing.",
          price: 14,
          tags: ["GF"]
        },
        {
          name: "Chicken Larb",
          description: "Lemongrass, thai herbs, tomatoes, cucumber, roasted rice powder, green onion, cilantro, chili lime juice & fresh cabbage.",
          price: 15,
          tags: ["GF", "MEDIUM"]
        },
        {
          name: "Thailand Street",
          description: "Choice of Beef (+$2) Shrimp or Squid. Lemongrass, thai herbs, tomato, cucumber, roasted rice powder, green onion, cilantro, chili lime & fresh cabbage.",
          price: 16,
          tags: ["GF", "MEDIUM"]
        }
      ]
    },
    {
      id: "sides",
      title: "Sides",
      subtitle: "Steamed extras and more",
      subgroups: [
        {
          id: "rice-sauces",
          title: "Rice and Sauces",
          listMode: true,
          items: [
            { name: "Large Peanut Sauce", price: 4 },
            { name: "Small Peanut Sauce", price: 2 },
            { name: "Jasmine/Brown Rice", price: 4 },
            { name: "Sticky Rice", price: 4 }
          ]
        },
        {
          id: "steamed",
          title: "Steamed",
          listMode: true,
          items: [
            { name: "Vegetables", price: 6 },
            { name: "Noodles", price: 5 },
            { name: "Chicken or Beef", price: 6 },
            { name: "Tofu", price: 5 }
          ]
        },
        {
          id: "extras",
          title: "Extra Additions",
          subtitle: "for most menu items",
          listMode: true,
          items: [
            { name: "Vegetables", price: 3 },
            { name: "Chicken/Tofu", price: 4 },
            { name: "1 pc Shrimp", price: 1.5 }
          ]
        }
      ]
    },
    {
      id: "drinks",
      title: "Drinks",
      subtitle: "Refreshing beverages",
      subgroups: [
        {
          id: "juice-soda",
          title: "Juice & Soda",
          listMode: true,
          groupPrice: 4,
          items: [
            { name: "Watermelon" },
            { name: "Pineapple" },
            { name: "Lychee" },
            { name: "Peach" },
            { name: "Mango" },
            { name: "Soda (Refill), Raspberry Lemonade" }
          ]
        },
        {
          id: "coffee-tea",
          title: "Coffee & Tea",
          listMode: true,
          groupPrice: 4,
          items: [
            { name: "Thai Iced Coffee" },
            { name: "Thai Iced Tea" },
            { name: "Home Iced Tea" }
          ]
        }
      ]
    },
    {
      id: "desserts",
      title: "Desserts",
      subtitle: "A sticky-sweet ending",
      items: [
        {
          name: "Mango Sweet Sticky Rice",
          description: "(Seasonal Mango) Fresh cut cold mango served with warm sticky-sweet rice.",
          price: 8,
          tags: ["VG", "GF"]
        },
        {
          name: "Sweet Sticky Rice",
          description: "Warm sticky-sweet rice.",
          price: 5,
          tags: ["VG", "GF"]
        }
      ]
    }
  ]
};
